import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Link from '@cotyorg/ccx-atoms/Link';
import StandardLayout from '../../templates/StandardLayout';
import { HeaderSection } from './Sections/Header/Header';
import { VideoSection } from './Sections/Video/Video';
import { KnowledgeSection } from './Sections/Knowledge/Knowledge';
import { RecyclingSection } from './Sections/Recycling/Recycling';

const ParfumPage = ({ sectionHeadings, videos, hero, link }) => (
  <StandardLayout>
    <div className="parfum-page">
      {R.path(['header', 'heading'])(sectionHeadings) && (
        <HeaderSection sectionHeadings={sectionHeadings} />
      )}
      <Link link={link.url} title={link.text}>
        {R.path(['image', 'imageSrc'], sectionHeadings) && (
          <Picture
            alt={R.path(['image', 'imageAlt'], sectionHeadings)}
            src={R.path(['image', 'imageSrc'], sectionHeadings)}
            srcset={R.path(['image', 'imageSrcSet'], sectionHeadings)}
          />
        )}
      </Link>
      {!!R.prop('mainVideo', videos) && <VideoSection videos={videos} />}

      <KnowledgeSection sectionHeadings={sectionHeadings} />

      <OptionalSection
        renderCondition={R.prop('recycling')(hero)}
        section={() => <RecyclingSection sectionHeadings={sectionHeadings} />}
      />
    </div>
  </StandardLayout>
);

ParfumPage.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.instanceOf(PropTypes.object),
  hero: PropTypes.arrayOf(PropTypes.object),
  link: PropTypes.instanceOf(PropTypes.object),
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
  videos: R.prop('videos', content),
  hero: R.prop('hero', content),
  link: R.prop('link', content),
}))(ParfumPage);
